<template>
  <div id="app">
    <app-header></app-header>
    <main>
      <h1>Apply for a Free Public Good Account</h1>
      <app-form></app-form>
    </main>
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppForm from "./components/AppForm.vue";

export default {
  components: {
    AppHeader,
    AppForm
  }
};
</script>

<style lang="scss">
@import "assets/scss/main.scss";
</style>